import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { DialogActions } from '@material-ui/core';
import { Link } from "react-router-dom";

import { Medications, Medication } from '.';
import { alertAction, drugSearchAction } from '../_actions';
import { drugService, prescriptionService } from '../_services';
import { getPersonId, env } from '../_helpers';
import config from '../config';


class DrugSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMax: false,
            isRedirect: false
        };
    }

    componentDidMount() {
        const { dispatch, preload } = this.props;

        if (preload) {
            dispatch(drugSearchAction.preload(preload));
        } else {
            dispatch(drugSearchAction.init());
        }
    }

    handleSearch = (event) => {
        const { dispatch } = this.props;
        const searchKey = event.target.value;

        dispatch(drugSearchAction.change(searchKey));
        dispatch(drugSearchAction.clearSearch());

        if (searchKey.length > 2) {
            dispatch(drugSearchAction.search(searchKey));
        }
    }

    isDrugExisted = (drugName) => {
        const { drugs } = this.props;
        const existed = drugs.find(o => o.name === drugName) !== undefined;

        return existed;
    }
     
    isDuplicatePrescription = async (drug) => {
        const res = await prescriptionService.CheckPrescriptionDuplicted(getPersonId(), drug);
        const { isDrugExisted } = res.data;
        return isDrugExisted ;
    }

    isDrugDosageExisted = (drug ) => {
        const { drugs } = this.props;
         return drugs.find(o => {
            if(o.name === drug.name){
               for( let i=0; i<drug.ingredients.length; i++){
                   if(o.ingredients[i].strength != drug.ingredients[i].strength)
                        return false;
               } 
               return true;
            } else {
                return false;
            }
        })
    }

    handleSelect = async (drug) => {
        const { dispatch } = this.props;
        const res = await drugService.getByName(drug.name);
        const multipleDrugs = res.data;
        if (multipleDrugs.length > 1) {
            this.props.selectDrugAction(multipleDrugs, drug);
        } else {
            if (!this.isDrugExisted(drug.name)) {
                dispatch(drugSearchAction.showUsage(drug));
            } else {
                dispatch(alertAction.warning('This drug is already added.'));
            }
        }
    }

    handleMultipleSelect = (drug) =>{
        const { dispatch } = this.props;
         if(!this.isDrugDosageExisted(drug)){
            dispatch(drugSearchAction.showUsage(drug));
         } else {
            dispatch(alertAction.warning('This drug is already added.'));
         }
    }

    handleAdd = async (usage) => {
        const { dispatch, drug, drugs, onMedicationsChanged, hideDuration, prescriptionObj = {} } = this.props;
        // let isDrugExisted;
        // isDrugExisted =!hideDuration && await this.isDuplicatePrescription(drug);
        
        const res = await prescriptionService.checkMedicationNumbers(getPersonId(), prescriptionObj);
        const isMedicationNumberAvailable = res.data.success;
        if (!isMedicationNumberAvailable) {
            this.setState({ isMax: true });
            return;
        }
        
        if (true) {
            drug.usages = [usage];
            const newDrugs = [...drugs, drug];

            dispatch(drugSearchAction.addDrug(newDrugs));
            onMedicationsChanged(newDrugs);
        } else {
            dispatch(alertAction.warning('You have already requested this medication and its approval by one of our doctors is pending.'));
        }
    }

    handleCancel = () => {
        const { dispatch } = this.props;
        dispatch(drugSearchAction.clearSearch());
    }

    handleEditUsage = async (drug, usage) => {
        let { dispatch, drugs, onMedicationsChanged, hideDuration} = this.props;
        drugs = JSON.parse(JSON.stringify(drugs));  // deep copy so it won't affect the medicalInfo currently taken medication
        
        // let isDrugExisted;
        // isDrugExisted =!hideDuration && await this.isDuplicatePrescription(drug);

        if (true){

          const newDrugs = [...drugs].map(o => {
            if (o.name === drug.name) {
                o.usages = [...o.usages, usage];
            }

            return o;
        });

        dispatch(drugSearchAction.updateDrugUsage(newDrugs));
        onMedicationsChanged(newDrugs);
        } else {
            dispatch(alertAction.warning('You have already requested this medication and its approval by one of our doctors is pending.'));
        }
    }

    /**
     * Delete a tag item
     * @param {item} i 
     */
    handleDelete = (drug) => {
        const { dispatch, drugs, onMedicationsChanged } = this.props;
        const newDrugs = drugs.filter((o) => o.name !== drug.name);

        dispatch(drugSearchAction.removeDrug(newDrugs));
        onMedicationsChanged(newDrugs);
    }

    /**
     * Ask the medication's frequency
     */
    handleShowUsage = (drug) => {
        const { dispatch } = this.props;
        dispatch(drugSearchAction.showUsage(drug));
    }

    renderDrugs() {
        const { drugs, hideDuration, allowEdit } = this.props;

        if (drugs && drugs.length > 0) {
            return (
                <Medications items={drugs} handleDelete={this.handleDelete} hideDuration={hideDuration}
                    allowEdit={allowEdit} onEditUsage={(drug, usage) => this.handleEditUsage(drug, usage)}

                />
            );
        } else {
            return '';
        }
    }

    renderSearchList() {
        const { searchList, isCrossOut } = this.props;

        if (searchList && searchList.length > 0) {
            return (
                <div className="search-list">
                    <ul className="ul-suggestions">
                        {
                            searchList.map((item, index) => {
                                let classes = '';
                                let disabled = false;

                                // cross out medication, red and cross out
                                if ((item.filter === 'CROSS_OUT' || item.name == 'PLAN B' || item.name == 'BACKUP PLAN ONESTEP') && isCrossOut  ) {
                                    classes = `${classes} cross-out`;
                                    disabled = true;
                                }

                                return <li key={index} className={classes} 
                                    data-test-id={`drug-search__search-list__${index}`}
                                    onClick={(event) => {
                                        if (disabled) {
                                            event.preventDefault();
                                        } else {
                                            this.handleSelect(item);
                                        }
                                    }}
                                >
                                    <span className="medication">{item.name}</span>
                                    <span className="ingredients">
                                        Ingredients:
                                        {
                                            item.ingredients.map((ing) => {
                                                return ' ' + ing.ingredient_name + '; ';
                                            })
                                        }
                                    </span>
                                </li>;
                            })
                        }
                    </ul>
                </div>
            );
        } else {
            return '';
        }
    }

    renderMultipleDrugs() {
        const { multipleDrugs, drug } = this.props;

        if (multipleDrugs && multipleDrugs.length > 0 && drug) {
            return (
                <div className="multiple-drugs">
                    <div>
                        <div className="select-drug">{drug.name}</div>
                        <div>
                            Select the specific medication based on Strength, Administration and Formulation:
                        </div>
                    </div>
                    <ul>
                        {
                            multipleDrugs.map((item, index) => {
                                return <li key={index} onClick={() => this.handleMultipleSelect(item)}>
                                    <span className="ingredients-medication">
                                        Ingredients:
                                        {
                                            item.ingredients.map((ing) => {
                                                return ' ' + ing.ingredient_name + ' - ' + ing.strength + ' ' + ing.strength_unit + '; ';
                                            })
                                        }
                                    </span>
                                    <span className="administration">
                                        Administration: {item.administrations[0]} | Formulation: {item.formulations[0]}
                                    </span>
                                </li>;
                            })
                        }
                    </ul>
                </div>
            );
        } else {
            return '';
        }
    }

    renderUsage() {
        const { drug, showUsage, hideDuration, isUsageHide } = this.props;

        if (showUsage) {
            return (
                <Medication item={drug} hideDuration={hideDuration}
                    onAddUsage={(usage) => this.handleAdd(usage)}
                    onCancelUsage={this.handleCancel} isUsageHide={isUsageHide} 
                />
            );
        } else {
            return '';
        }
    }

    renderMaxMedsPopup() {
        return <Dialog
            fullWidth={true}
            maxWidth="md"
            open={true}
        >
            <DialogTitle className="text-center">
                <i className="fas fa-exclamation-triangle text-warning mb-3" style={{fontSize: "50px"}}></i>
                <div>Maximum number of medications has been reached</div>
            </DialogTitle>
            <DialogContent className="text-center">
                <div style={{ fontSize: 16 }}>
                For your safety, you may only request 5 medications per day using Instore.AskMedication.com. If you wish to obtain 6 or more medications, please book an appointment with a doctor at the Richmond In-Store Medical Clinic by
                     <a href="#" onClick={(e) => {
                        e.preventDefault();
                        this.setState({ isRedirect: true });
                    }}> navigating to Instoremed.com</a>.
                </div>
            </DialogContent>
            <DialogActions className="bg-warning">
                <button className="btn mx-auto w-100 text-white font-weight-bold" onClick={() => this.setState({ isMax: false })}>Close</button>
            </DialogActions>
        </Dialog>
    }

    renderRedirect() {
        return <Dialog
            fullWidth={true}
            maxWidth="sm"
            open={true}
        >
            <DialogTitle className="text-center bg-danger">
                <i className="fas fa-exclamation-triangle mb-2 text-white" style={{fontSize: "50px"}}></i>
                <div className="text-white">Redirecting</div>
            </DialogTitle>
            <DialogContent className="text-center bg-danger text-white">
                <div style={{ fontSize: 16 }}>
                    You are about to be redirected to the {/*<a href={config.southVanHost}>*/} Richmond In-Store Medical Clinic{/*</a>*/} appointment booking site. Your current medication request will be cancelled. Please click "OK" to continue.
                </div>
            </DialogContent>
            <DialogActions className="d-flex justify-content-center m-3">
                <button className="btn btn-danger mr-2 mt-4 btn-block" onClick={() => window.location.href = config.appointmentHost}>OK</button>
                <button className="btn btn-outline-secondary mr-2 mt-4 btn-block" onClick={() => this.setState({ isRedirect: false})}>Cancel</button>
            </DialogActions>
        </Dialog>
    }

    render() {
        const { searchKey, drugs, searchList, isCrossOut } = this.props;
        const placeholder = drugs.length > 0 ? 'Type medication name to search' : 'Type medication name to search';
        return (
            <div id="drug-search" className="py-1">
                {this.renderDrugs()}
                { isCrossOut && searchList && searchList.length > 0
                    && (searchList.filter(item => item.filter == 'CROSS_OUT' || item.name == 'PLAN B' || item.name == 'BACKUP PLAN ONESTEP').length > 0)
                    && <p style = {{color:"red"}}> If a prescription is <span style={{textDecoration:"line-through"}}>crossed out</span>, this is because it cannot be refilled through Instore.AskMedication.com. Please contact a doctor at InstoreMed.com to consider refilling <span style={{textDecoration:"line-through"}}>crossed out</span> medications. </p>
                }
                <input type="text" className="form-control" placeholder={placeholder}
                    value={searchKey} onChange={this.handleSearch} onFocus={this.handleSearch} 
                    data-test-id="drug-search__input"
                />
                {this.renderSearchList()}
                {this.renderMultipleDrugs()}
                {this.renderUsage()}
                {this.state.isMax && this.renderMaxMedsPopup()}
                {this.state.isRedirect && this.renderRedirect()}
            </div>
        );
    }
}


DrugSearch.propTypes = {
    dispatch: PropTypes.func,
    onMedicationsChanged: PropTypes.func,
    searchKey: PropTypes.string,
    searchList: PropTypes.array,
    showUsage: PropTypes.bool,
    multipleDrugs: PropTypes.array,
    drug: PropTypes.object,
    drugs: PropTypes.array,
    preload: PropTypes.array,
    hideDuration: PropTypes.bool,
    allowEdit: PropTypes.bool,
    isCrossOut: PropTypes.bool,
};


function mapStateToProps(state) {
    const { prescriptionObj } = state.prescription;
    
    const { searchList, multipleDrugs, showUsage, drug } = state.drugSearch;
    let { searchKey, drugs } = state.drugSearch;

    if (searchKey === undefined) {
        searchKey = '';
    }

    if (drugs === undefined) {
        drugs = [];
    }

    return {
        searchKey,
        searchList,
        multipleDrugs,
        showUsage,
        drug,
        drugs,
        prescriptionObj
    };
}

function mapDispatchToProps(dispatch) {
    return {
        selectDrug: (drug) => dispatch(drugSearchAction.selectDrug(drug)),
        selectDrugAction: (multipleDrugs, drug) => dispatch(drugSearchAction.selectDrugAction(multipleDrugs, drug)),
        dispatch
    };
}

const temp = connect(mapStateToProps, mapDispatchToProps)(DrugSearch);

export { temp as DrugSearch };